import { ComponentRef, Injectable } from '@angular/core';
import {
  DialogCloseResult,
  DialogRef,
  DialogResult,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { ApplyCptCodesComponent } from '../components/apply-cpt-codes/apply-cpt-codes.component';
@Injectable({
  providedIn: 'root',
})
export class ApplyCptCodesService {
  constructor(private dialogService: DialogService) {}

  public open(): {
    result$: Observable<DialogCloseResult | DialogResult>;
    instance: ApplyCptCodesComponent;
  } {
    const dialog: DialogRef = this.dialogService.open({
      content: ApplyCptCodesComponent,
      height: 'auto',
      maxHeight: '90vh',
      width: '530px',
      cssClass: 'apply-cpt-codes',
    });

    // ComponentRef<ScheduleTimeComponent>
    const content: ComponentRef<ApplyCptCodesComponent> =
      dialog.content as ComponentRef<ApplyCptCodesComponent>;
    const instance: ApplyCptCodesComponent = content.instance;

    return {
      result$: dialog.result as Observable<DialogCloseResult | DialogResult>,
      instance,
    };
  }
}
